import React, {useCallback, useState} from 'react';
import './Quiz.scss';
import QuizQuestion from './QuizQuestion';
import t from 'rcm-i18n';
import {QuizQuestionConfig} from '../../types';
interface Props {
    quizQuestions: QuizQuestionConfig[];
    onPassedQuiz: () => void;
}

const Quiz = ({quizQuestions, onPassedQuiz}: Props) => {
    const [invalidQuestionIndexes, setInvalidQuestionIndexes] = useState([]);
    const [selectedChoiceIndexByQuestionIndex, setSelectedChoiceIndexByQuestionIndex] = useState({});

    const questionSelectedChoiceIsValid = useCallback((question, questionIndex) => {
       const choiceIndex = selectedChoiceIndexByQuestionIndex[questionIndex];
       return choiceIndex !== undefined && question.choices[choiceIndex].isAcceptable;
    }, [selectedChoiceIndexByQuestionIndex]);

    const handleContinueButtonClick = useCallback(
        () => {
            const newInvalidQuestionIndexes = [];
            quizQuestions.forEach((question, questionIndex) => {
                if (!questionSelectedChoiceIsValid(question, questionIndex)) {
                    newInvalidQuestionIndexes.push(questionIndex);
                }
            });
            setInvalidQuestionIndexes(newInvalidQuestionIndexes);
            if (newInvalidQuestionIndexes.length === 0) {
                onPassedQuiz();
            }
        },
        [quizQuestions, questionSelectedChoiceIsValid]
    );

    const handleRadioInputSelect = useCallback(
        (questionIndex: number, choiceIndex: number) => {
            const newChoiceData = {...selectedChoiceIndexByQuestionIndex, [questionIndex]: choiceIndex};
            setSelectedChoiceIndexByQuestionIndex(newChoiceData);
        },
        [selectedChoiceIndexByQuestionIndex]
    );

    return <div className="block-certification-training-Quiz">
        {invalidQuestionIndexes.length > 0 &&
            <div className="alert alert-warning" role="alert">
                {t('Not all answers were correct. Please try again.')}
            </div>
        }
        <div className="quiz-questions-container">
            {quizQuestions.map((question, questionIndex) =>
                <QuizQuestion
                    key={questionIndex}
                    question={question}
                    value={selectedChoiceIndexByQuestionIndex[questionIndex]}
                    invalidQuestionIndexes={invalidQuestionIndexes}
                    questionIndex={questionIndex}
                    onValueChange={handleRadioInputSelect}/>
            )}
        </div>
        <button className="btn btn-primary" onClick={handleContinueButtonClick}>
            {t('Check Answers')}
        </button>
    </div >;
};

export default Quiz;
